import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import thaiButtonStyles from "theme/thaiButtonStyles";

const ChiStyledButton = styled(Button)(({ theme }) => ({
  width: "80%",
  fontSize: "18px",
  fontFamily: '"Noto Serif JP", serif',
  fontWeight: "bold",
  lineHeight: 1,
  padding: "8px",
  borderRadius: "27px",
  border: "2px solid white",
  height: "54px",
  background: "transparent",
  textTransform: "none",
  ...thaiButtonStyles,
  "&:hover": {
    opacity: 0.9, // ホバー時の軽いエフェクト
  },
}));

export default ChiStyledButton;
